import React, { useState, useEffect } from "react";
import logo from "../../assets/images/endless-logo.png";
import man from "../../assets/images/dashboard/user.png";
import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./main.css";
import { Link, Redirect } from "react-router-dom";
import socket from "../../utlis/socket";
import rsaWrapper from "../../utlis/rsa-wrapper";
import aesWrapper from "../../utlis/aes-wrapper";
import { withRouter } from "react-router";
import AuthenticationService from "../../services/authenticationService";
import app, {
  googleProvider,
  facebookProvider,
  twitterProvider,
  githubProvider,
} from "../../data/base";

import store from "store";
class Signin extends React.Component {
  state = {
    email: "",
    password: "",
    value: "",
    AESKey: "",
    connection: false,
    checkbox: false,
  };
  componentDidMount() {
    if (store.get("AESKey")) {
      this.setState({ connection: true, AESKey: store.get("AESKey") });
    }
  }
  componentDidMount() {
    if (store.get("authToken")) {
      this.props.history.push(`${process.env.PUBLIC_URL}/products/all`);
    }
  }

  socketConnect() {
    socket.connect();
    var they = this;
    socket.on("CLIENT_PRIVATE_KEY", (privateKey) => {
      socket.emit("SECRET_KEY");
      socket.on("SECRET_KEY", (key) => {
        rsaWrapper
          .privateDecrypt(privateKey, key)
          .then((SECRET_KEY) => {
            var AESKey = SECRET_KEY;
            localStorage.setItem("AESKey", AESKey);
            they.setState({ connection: true, AESKey });
            // if (window.requestIdleCallback) {
            //   const fingerprint = btoa(navigator.userAgent);
            //   //console.log(
            //     fingerprint,
            //     "---",
            //     navigator.userAgent,
            //     "fingerPrint"
            //   );
            //   // cookie.set("fngprt", fingerprint);
            //   cookie.set("fngprt", fingerprint, {
            //     secure: process.env.NODE_ENV !== "dev"
            //   });
            //   //console.log(cookie.get("fngprt"), "get");
            // } else {
            //   const fingerprint = btoa(navigator.userAgent);
            //   //console.log(
            //     fingerprint,
            //     "---",
            //     navigator.userAgent,
            //     "fingerPrint"
            //   );
            //   // cookie.set("fngprt", fingerprint);
            //   cookie.set("fngprt", fingerprint, {
            //     secure: process.env.NODE_ENV !== "dev"
            //   });
            //   //console.log(cookie.get("fngprt"), "get");
            // }
          })
          .catch((err) => {
            //console.log("error occurred ", err.name);
            //console.log("error occurred code ", err.code);
          });
      });
    });
  }
  onSubmit() {
    const { connection } = this.state;
    // toast.success("---------" + connection+"----------");
    // if (connection) {
    this.loginAuth();
    // } else {
    //   AuthenticationService.socketConnect().then(response => {
    //     this.setState({ connection: true, AESKey: response });
    //     this.loginAuth();
    //   });
    // }
  }
  loginAuth() {
    const { email, password } = this.state;
    const AESKey = store.get("AESKey");
    var they = this;
    if (password.length > 2 && email.length > 5) {
      // aesWrapper.encryptMessage(AESKey, password).then(encryptedPassword => {
      // password = encryptedPassword;
      AuthenticationService.emailAuthentication(
        email,
        password // encryptedPassword
      ).then((response) => {
        if (!response.error) {
          // toast.success(response.userMessage);
          console.log("Response =>", { response })
          var staffMember = response.data.staffMember;
          store.set("staffMember", response.data.staffMember);
          store.set("authToken", response.data.authToken);
          //console.log({ response });
          //console.log("they.props", they.props);
          store.set("enquiries", response.data.enquiries);
          var event = new CustomEvent("enquiries", {
            detail: { enquiries: response.enquiries || [] },
          });
          document.dispatchEvent(event);
          var event = new CustomEvent("login", {
            detail: { authToken: true },
          });
          document.dispatchEvent(event);
          they.props.history.replace("/products/all");
        } else {
          // toast.error(response.userMessage);
        }
      });
      // });
    }
  }
  render() {
    const { email, password, value } = this.state;
    const AESKey = store.get("AESKey");
    const setValue = (value) => {
      //console.log({ value });
      this.setState({ value });
    };
    const setEmail = (email) => {
      //console.log({ email });
      this.setState({ email });
    };
    const setPassword = (password) => {
      //console.log({ password });
      this.setState({ password });
    };
    // const [value, setValue] = useState(
    //   localStorage.getItem("profileURL" || man)
    // );

    // useEffect(() => {
    //   localStorage.setItem("profileURL", value);
    // }, [value]);

    // const loginAuth = async () => {
    //   try {
    //     await app.auth().signInWithEmailAndPassword(email, password);
    //     setValue(man);
    //     this.props.history.push(
    //       `${process.env.PUBLIC_URL}/products/all`
    //     );
    //   } catch (error) {
    //     setTimeout(() => {
    //       toast.error(
    //         "Oppss.. The password is invalid or the user does not have a password."
    //       );
    //     }, 200);
    //   }
    // };

    // const googleAuth = async () => {
    //   try {
    //     app
    //       .auth()
    //       .signInWithPopup(googleProvider)
    //       .then(function(result) {
    //         setValue(result.user.photoURL);
    //         setTimeout(() => {
    //           this.props.history.push(
    //             `${process.env.PUBLIC_URL}/products/all`
    //           );
    //         }, 200);
    //       });
    //   } catch (error) {
    //     setTimeout(() => {
    //       toast.error(
    //         "Oppss.. The password is invalid or the user does not have a password."
    //       );
    //     }, 200);
    //   }
    // };

    // const facebookAuth = async () => {
    //   try {
    //     app
    //       .auth()
    //       .signInWithPopup(facebookProvider)
    //       .then(function(result) {
    //         setValue(result.user.photoURL);
    //         setTimeout(() => {
    //           this.props.history.push(
    //             `${process.env.PUBLIC_URL}/products/all`
    //           );
    //         }, 200);
    //       });
    //   } catch (error) {
    //     setTimeout(() => {
    //       toast.error(
    //         "Oppss.. The password is invalid or the user does not have a password."
    //       );
    //     }, 200);
    //   }
    // };
    // const twitterAuth = async () => {
    //   try {
    //     app
    //       .auth()
    //       .signInWithPopup(twitterProvider)
    //       .then(function(result) {
    //         setValue(result.user.photoURL);
    //         setTimeout(() => {
    //           this.props.history.push(
    //             `${process.env.PUBLIC_URL}/products/all`
    //           );
    //         }, 200);
    //       });
    //   } catch (error) {
    //     setTimeout(() => {
    //       toast.error(
    //         "Oppss.. The password is invalid or the user does not have a password."
    //       );
    //     }, 200);
    //   }
    // };
    // const githubAuth = async () => {
    //   try {
    //     app
    //       .auth()
    //       .signInWithPopup(githubProvider)
    //       .then(function(result) {
    //         setValue(result.user.photoURL);
    //         setTimeout(() => {
    //           this.props.history.push(
    //             `${process.env.PUBLIC_URL}/products/all`
    //           );
    //         }, 200);
    //       });
    //   } catch (error) {
    //     setTimeout(() => {
    //       toast.error(
    //         "Oppss.. The password is invalid or the user does not have a password."
    //       );
    //     }, 200);
    //   }
    // };

    return (
      <div>
        <div className="page-wrapper">
          <div className="container-fluid">
            {/* <!-- login page start--> */}
            <div className="authentication-main">
              <div className="row">
                <div className="col-md-12">
                  <div className="auth-innerright">
                    <div className="authentication-box">
                      {/* <div className="text-center">
                          <img src={logo} alt="" /></div> */}
                      <div
                        className="card mt-4 border-0"
                        style={{ boxShadow: "1px 5px 24px 0 rgba(0, 0, 0, 0.21)", padding:"20px" }}
                      >
                        <div className="card-body" >
                          <div className="text-center card_header">
                            <h4>LOGIN</h4>
                            <h6>Enter your Username and Password </h6>
                          </div>
                          <form className="theme-form form-wrapper">
                            <div className="form-group form-fields">
                              <label className="col-form-label pt-0">
                                Username
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email address"
                              />
                              {/* {errors.email && 'Email is required'} */}
                            </div>
                            <div className="form-group form-fields">
                              <label className="col-form-label">
                                Password
                              </label>
                              <input
                                className="form-control"
                                type="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              {/* {errors.password && 'Email is required'} */}
                            </div>
                            <div className="checkbox p-0 checkbox-field">
                              <input id="checkbox1" type="checkbox" />
                              <label htmlFor="checkbox1">Remember me</label>
                            </div>
                            {/* <div
                                className="checkbox p-0"
                                style={{ fontSize: "12px" }}
                              >
                                <input
                                  id="checkbox1"
                                  type="checkbox"
                                  onClick={() =>
                                    this.state.checkbox
                                      ? this.setState({ checkbox: false })
                                      : this.setState({ checkbox: true })
                                  }
                                />
                                <label htmlFor="checkbox1">Remember me</label> */}
                            {/* <label htmlFor="checkbox1">
                                  {`by signing up, I accept `}
                                </label>
                                <a target="_blank">
                                  &nbsp;&nbsp;
                                  {`Terms & Conditions`}
                                </a> */}
                            {/* </div> */}
                            <div className="form-group form-row mt-3 mb-0 action-button">
                              <button
                                className=""
                                type="button"
                                // disabled={this.state.checkbox ? false : true}
                                onClick={() => this.onSubmit()}
                              >
                                Login
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- login page end--> */}
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default withRouter(Signin);
